import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getVideoDesignElementUrl,
  getIsCampaignPreview
} from '../../redux/modules/campaignLandingPage';
import { isiOS } from '../../utils';
import styles from './VideoElement.module.less';

const VideoElement = ({ videoElementUrl, isCampaignPreview, element }) => {
  const previewUrl = videoElementUrl || element?.media?.rawPath || element?.media?.originalPath;

  if (!previewUrl) {
    return isCampaignPreview ? (
      <section className={styles.vpVideoDesignElementWarning}>
        Video will be available after your campaign is saved and the video is processed.
      </section>
    ) : null;
  }

  const videoSource = `${previewUrl}${isiOS() ? '#t=0.0001' : ''}`;

  return (
    <section className={styles.vpVideoDesignElementContainer}>
      <video className={styles.vpVideoElementPreview} controls key={videoElementUrl}>
        <source src={videoSource} />
      </video>
    </section>
  );
};

VideoElement.propTypes = {
  videoElementUrl: PropTypes.string,
  isCampaignPreview: PropTypes.bool,
  element: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  return {
    videoElementUrl: getVideoDesignElementUrl(state, ownProps.qid),
    isCampaignPreview: getIsCampaignPreview(state, ownProps.qid)
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VideoElement);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoElement.jsx